import { SxProps, Theme } from '@mui/system';

const styles = {
  title: {
    fontWeight: '700',
    fontSize: 16,
    color: 'common.grey850',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
